import WistiaHelper from '../../common/gdpr/wistia-helper';
import WG from '../../common/modules/wg';
import merge from 'lodash.merge';

const global = window.wrike;

class DeclineInvitationPage {
    constructor() {
        this.$modalVideo = $('#contactModalVideo');
        this.$modalVideoInner = $('#contactModalVideoInner');
        this.$form = $('.decline-invitation-intro__form');
        this.wistiaId = this.$modalVideo.data('wistia-id');
    }

    init() {
        $('.wg-header')
            .wgInstance()
            .setTheme('dark');

        this.initContactUs(
            'decline-invitation-contact',
            'contact_sales_form__submit',
            'contact_sales',
            'outro_form',
            'regular_contact'
        );

        this.initVideo();
        this.initDecliningHandler();
    }

    initDecliningHandler() {
        this.$form.data('disabled', 'disabled');

        this.$form.on('submit', (event) => {
            if (this.$form.data('disabled') === 'enabled') {
                return;
            }
            event.preventDefault();
            this.checkHandler();
        });
    }

    checkHandler() {
        const params = window.location.search.slice(1);

        $.ajax({
            type: 'POST',
            url: 'https://' + window.location.host + '/ui/am_user_invitation_decline',
            headers: {
                'Wrike-Client-Id': 'sitev6'
            },
            data: params,
            dataType: 'JSON'
        }).always(() => {
            this.submitForm(this.$form);
        });
    }

    submitForm() {
        this.$form.data('disabled', 'enabled');
        this.$form.submit();
    }

    initVideo() {
        this.$modalVideo.on('show.wg.modal', () => {
            WG.GdprUserCentrics.makeConditionalCallback(() => {
                if (this.wistiaId) {
                    WistiaHelper.appendWistiaVideo(this.$modalVideoInner, this.wistiaId, '', '');
                }
            }, WG.GdprUserCentrics.ConsentCategories.Advertising)();
        });

        this.$modalVideo.on('hide.wg.modal', () => {
            this.$modalVideoInner.children(':not(.modal-video__close)').detach();
        });
    }

    initContactUs(formId, event, subtype, formName, content) {
        const $form = $(`#${formId}`);

        if ($form.length) {
            const contactSales = new ContactSales({
                subType: $form.data('subtype'),
                clientId: $form.data('clientid'),
                $form: $form,
                marketoId: 2005,
                marketoFormType: 'contact_sales',
                onSuccess: function(sales) {
                    const formData = sales.formData;
                    const defaultData = {
                        value: {
                            type: 'contact',
                            subtype: subtype,
                            form: formName,
                            content: content,
                            email: formData.email,
                            name: formData.name,
                            phone_number: `${formData['code']} ${formData['phone']}`,
                            description: formData.question,
                            job_title: formData.job_role,
                            job_role: formData.job_level
                        }
                    };

                    const statSiteData = {
                        event: event
                    };

                    const airPrData = {
                        event: 'non_trial_form__submitted',
                        value: {
                            event: 'contact_sales_form__submitted'
                        }
                    };

                    global.trackEventForm(merge(defaultData, statSiteData), false);
                    new WG.AirPrTracking(merge(defaultData, airPrData));
                }
            });
            contactSales.init();
        }
    }
}

$(function() {
    const declineInvitationPage = new DeclineInvitationPage();

    declineInvitationPage.init();
});



// WEBPACK FOOTER //
// ./assets/js/projects/decline-invitation/decline-invitation.js